import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from "react-bootstrap";
import { 
    FaGlobe, 
    FaIdCard, 
    FaCloud, 
    FaStickyNote,
    FaInfoCircle
} from "react-icons/fa";

const DomainView = ({ domainData }) => {
    const [editedDomainData, setEditedDomainData] = useState(domainData);

    useEffect(() => {
        setEditedDomainData(domainData);
    }, [domainData]);

    const getDisplayValue = (value) => value || "--";

    const fieldGroups = [
        {
            title: "Basic Information",
            icon: <FaGlobe className="text-primary" />,
            fields: [
                { 
                    name: 'domain_name', 
                    label: 'Domain Name', 
                    icon: <FaGlobe size={14} />, 
                    value: getDisplayValue(editedDomainData?.domain_name) 
                },
                { 
                    name: 'zoneid', 
                    label: 'Zone ID', 
                    icon: <FaIdCard size={14} />, 
                    value: getDisplayValue(editedDomainData?.zoneid) 
                },
                { 
                    name: 'provider', 
                    label: 'Provider', 
                    icon: <FaCloud size={14} />, 
                    value: getDisplayValue(editedDomainData?.provider) 
                }
            ]
        },
        {
            title: "Additional Information",
            icon: <FaInfoCircle className="text-success" />,
            fields: [
                { 
                    name: 'remarks', 
                    label: 'Remarks', 
                    icon: <FaStickyNote size={14} />, 
                    value: getDisplayValue(editedDomainData?.remarks) 
                }
            ]
        }
    ];

    return (
        <div className="p-3">
            {fieldGroups.map((group, groupIndex) => {
                const visibleFields = group.fields;

                return (
                    <Card key={groupIndex} className="mb-4 shadow-sm border-0">
                        <Card.Header className="bg-light border-0 py-3">
                            <div className="d-flex align-items-center">
                                {group.icon}
                                <h5 className="mb-0 ms-2 fw-semibold text-dark">{group.title}</h5>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <Row className="g-0">
                                {visibleFields.map((field, fieldIndex) => (
                                    <Col md={field.name === 'remarks' ? 12 : 6} key={fieldIndex}>
                                        <div className={`p-3 border-bottom ${field.name !== 'remarks' ? 'border-end' : ''} domain-detail-item`}>
                                            <div className="d-flex align-items-start">
                                                <div className="text-muted me-3 mt-1">
                                                    {field.icon}
                                                </div>
                                                <div className="flex-grow-1">
                                                    <label className="text-muted small mb-1 d-block fw-medium">
                                                        {field.label}
                                                    </label>
                                                    <div className="text-dark fw-semibold">
                                                        {field.value}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </Card>
                );
            })}
        </div>
    );
};

export default DomainView;
